import { string, object, SchemaOf } from 'yup'

export interface IForgotPasswordSchema {
    email: string
}

const forgotPasswordSchema: SchemaOf<IForgotPasswordSchema> = object().shape({
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.'),
})

export default forgotPasswordSchema
